import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { MapItemComponent } from '@ui/shared/util-map';
import type { FoundingMapItemModel } from '../../entities/founding-map-item.model';
import { DetailViewModule } from '@ui/shared/ui-detail-view';

@Component({
    selector: 'ui-founding-map-item-popup-content',
    imports: [DetailViewModule],
    templateUrl: './founding-map-item-popup-content.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FoundingMapItemPopupContentComponent implements MapItemComponent<FoundingMapItemModel> {
    public mapItem = input<FoundingMapItemModel | undefined>();
}
